import moment from "moment";


export const today = () => {
  return moment()
};

export const yesterday = () => {
  return moment().subtract(1, 'day');
};

const valid_DD_MM_YYYY = (date, format = 'DD.MM.YYYY') => {
  if (!date || date.trim().length === 0) {
    return undefined
  }
  const momentDate = moment(date.trim(), format)
  return momentDate.isValid() ? momentDate : undefined;
};

export default valid_DD_MM_YYYY;
